import {
  AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_GET_PERMISSIONS,
} from 'react-admin'
import axios from 'axios'
import config from '../../config/config'

const { apiUrl, loginRedirectUri, loginUrl } = config

const cleanup = () => {
  // Remove the ?code&state from the URL
  window.history.replaceState({}, window.document.title, window.location.origin)
}

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    // 1. Redirect to the issuer to ask authentication
    if (!params || !params.code || !params.state) {
      setTimeout(() => {
        console.info(`redirect to ${loginUrl}&redirect_uri=${loginRedirectUri}`)
        window.location.href = `${loginUrl}&redirect_uri=${loginRedirectUri}`
      }, 250)
      return
    }
    return axios
      .post(`${apiUrl}/auth/login`, {
        code: params.code,
        redirectUri: loginRedirectUri,
      })
      .then((response) => {
        localStorage.setItem('accessToken', response.data.accessToken)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('authority', response.data.authority)
      })
      .catch((e) => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('authority')
        console.error(`error while login : ${e}`)
      })
      .finally(() => cleanup())
  }

  // Called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    const accessToken = localStorage.getItem('accessToken')
    const refreshToken = localStorage.getItem('refreshToken')
    if (accessToken !== null) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('authority')

      return axios
        .post(`${apiUrl}/auth/logout`, { refreshToken, postLogoutRedirectUri: loginRedirectUri })
        .then(() => {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('authority')
        })
        .catch((e) => {
          console.error(`error while logout : ${e}`)
        })
        .finally(() => cleanup())
    }
    return Promise.resolve()
  }

  // Called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return localStorage.getItem('accessToken') ? Promise.resolve() : Promise.reject()
  }

  if (type === AUTH_GET_PERMISSIONS) {
    const authority = localStorage.getItem('authority')
    return authority ? Promise.resolve() : Promise.reject()
  }

  return Promise.reject(Error('Unknown Method'))
}
